import React from 'react';
import { useTranslation } from 'react-i18next';

const HeroBanner = ({ bannerData }) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language || 'sr';

  const handleBannerNavigation = () => {
    if (bannerData.link) {
      window.location.href = bannerData.link;
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleBannerNavigation();
    }
  };

  return (
    <div
      role="link"
      tabIndex={0}
      onClick={handleBannerNavigation}
      onKeyDown={handleKeyDown}
      style={{
        position: 'relative',
        width: '100vw',
        height: '100vh',
        minHeight: '100vh',
        overflow: 'hidden',
        display: 'block',
        cursor: 'pointer',
      }}
    >
      <div className={`rs-banner ${bannerData.className} banner-home-style2`}>
        <div className="container h-100">
          <div className="content-wrap h-100 d-flex flex-column justify-content-center">
            <div className="hero-text d-none d-md-block">
              <span className="sub-title">
                {bannerData.smallTitleKey?.[currentLanguage]}
              </span>
              <h1 className="title">
                {bannerData.titleKey?.[currentLanguage]}
              </h1>
              <h2 className="title-small">
                {bannerData.subTitleKey?.[currentLanguage]}
              </h2>
            </div>
            <div className="btn-part wow fadeinup new hero-button d-none d-md-block">
              <a
                className="readon btn-text ticket"
                href={bannerData.buttonLink || bannerData.link}
                onClick={(event) => event.stopPropagation()}
              >
                <span>{bannerData.buttonTextKey?.[currentLanguage]}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;